import React from 'react';
import Joi from 'joi';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from 'components/atoms/Input/Input';
import { Button } from 'components/atoms/Button/Button';
import { Header } from 'components/atoms/Header/Header';
import { useFieldset, useDispatchCallback } from 'controls/hooks';
import { login, googleLogin, facebookLogin } from 'actions/auth';
import { SocialButton } from 'components/atoms/Button';
import { Language } from 'language/Language';
import { strings } from './strings';
import './_AuthForm.scss';

const loginForm = { email: '', password: '', rememberMe: false };
const loginSchema = {
  email: Joi.string().max(50).required().label('email'),
  password: Joi.string().required().label('password').max(30),
  rememberMe: Joi.boolean().required().label('remember'),
};

const AuthForm = () => {

  const dispatch = useDispatch();
  const { isWorking, errorMessage } = useSelector((state) => state.siteInfo);
  const { fields: { email, password }, submit } = useFieldset({
    schema: loginSchema,
    source: loginForm,
    onSubmit: useDispatchCallback(login),
  });
  const language = Language();

  const google = () => {
    dispatch(googleLogin());
  };

  const facebook = () => {
    dispatch(facebookLogin());
  };

  return (
    <>
      <form onSubmit={submit} className='form form__plugin login-form__plugin'>
        <Header text={strings[language].title} />
        <Input
          classes='input input__plugin'
          field={email}
          name={strings[language].email}
          style={{ height: '2rem' }}
          type='email'
        />
        <Input
          classes='input input__plugin'
          field={password}
          isPassword
          name={strings[language].password}
          style={{ marginBottom: '0', height: '2rem' }}
          type='password'
        />
        {errorMessage
          && (
          <p className='error__message'>
            {errorMessage.split('.')[0]}
          </p>
          )}
        <Button
          className='login__btn__plugin'
          isWorking={isWorking}
          text={strings[language].signIn}
          type='submit'
        />
        <div className='login__callToAction__plugin'>
          <Link
            to={`${language === 'japan' ? '/jp/私のアカウント' : '/my-account'}/lost-password?redirectTo=authPlugin`}
          >
            {strings[language].lostPassword}
          </Link>
        </div>
        <div>
          <p className='login__callToAction__plugin'>{strings[language].or}</p>
          <div className='login-buttons__plugin'>
            <SocialButton
              text={strings[language].facebook}
              icon='facebook f'
              onClick={facebook}
            />
            <SocialButton
              text={strings[language].google}
              icon='google'
              isImage
              onClick={google}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default AuthForm;
